import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FaEnvelopeOpen } from 'react-icons/fa';
import { appEnv } from '../lib/env';

export function ConfirmUnsubscriptionPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const email = searchParams.get('email');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!email || !token) {
      navigate('/error?type=invalid_url', { replace: true });
    }
  }, [email, token, navigate]);

  const handleVerify = async () => {
    if (!email || !token) return;
    
    setIsLoading(true);
    try {
      const response = await fetch(`${appEnv.apiBaseUrl}/newsletter/unsubscribe/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token }),
      });

      if (response.ok) {
        navigate('/unsubscribed', { replace: true });
      } else {
        const errorData = await response.json();
        if (errorData.message?.includes('expired')) {
          navigate('/error?type=token_expired', { replace: true });
        } else {
          navigate('/error?type=invalid_url', { replace: true });
        }
      }
    } catch (error) {
      console.error("Confirmation failed", error);
      navigate('/error?type=invalid_url', { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main-container">
      <div className="main-container-top" style={{ alignItems: 'center' }}>
        <h2>Verify Unsubscription</h2>
        <p className="main-text" style={{ textAlign: 'center' }}>
          Please click the button below to confirm your unsubscription.
        </p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px', width: '100%' }}>
        <FaEnvelopeOpen className="pulsing-icon" />
        <button 
          className="primary btn-glow" 
          onClick={handleVerify} 
          disabled={isLoading}
        >
          <span />
          {isLoading ? (
            <span>Confirming<span className="loading-dots"></span></span>
          ) : (
            <span>Verify now</span>
          )}
          <img src="/assets/arrow_right_white.svg" alt="" width="24" height="24" style={{ visibility: isLoading ? 'hidden' : 'visible' }} />
        </button>
      </div>
      <a href={appEnv.logoFrontendUrl} className="btn-link" style={{ marginTop: '16px' }}>
        <button className="secondary">
          <span />
          <span>HOME</span>
          <img src="/assets/arrow_right.svg" alt="" width="24" height="24" />
        </button>
      </a>
    </div>
  );
}
